module.exports = "title,abbreviation,attemptCount,uuid\nSnatch,SN,3,4ff4b822-5da9-48e1-9c84-bcd48ffb3372\nClean & Jerk,CJ,3,3df9eef1-669b-40c4-9c0f-a053673071a9\n"


//////////////////
// WEBPACK FOOTER
// ./node_modules/raw-loader!./src/data/lifts.csv
// module id = 1516
// module chunks = 0